module.exports = __webpack_public_path__ + "static/media/concept_for_vintage_poster_style_mural_2018.8a886b52.webp";